import { useQuery } from 'src/graphql';
import { CHECKLIST_QUESTIONS_PAGE_QUERY } from 'src/graphql/checklistQuestion/query';

export default ({
  limit = 1000,
  offset = 0,
  q = '',
  orderBy = 'id',
  orderDirection = 'asc',
  columnFilters = [],
  withDeleted = false,
}) =>
  useQuery(CHECKLIST_QUESTIONS_PAGE_QUERY, {
    variables: { limit, offset, q, orderBy, orderDirection, columnFilters, withDeleted },
    fetchPolicy: 'network-only',
  });
